import PropTypes from 'prop-types';

/**
 * Example usage:
 *
 * Exported just for convenience, in case you want to run propType checks on your component.
 * Note: some bundlers might remove these definitions during build time.
 */
export const propTypes = {
  getMessage: PropTypes.func,
  getMessageWithNamedParams: PropTypes.func,
};
